import type { SupportedLocale } from "@patient-watch/i18n";

/** Latest preferred_locale write requested per user - collapses sync-vs-UI races. */
const latestLocaleByUser = new Map<string, SupportedLocale>();
const writeSeqByUser = new Map<string, number>();

export function notePreferredLocaleIntent(userId: string, locale: SupportedLocale): number {
    latestLocaleByUser.set(userId, locale);
    const seq = (writeSeqByUser.get(userId) ?? 0) + 1;
    writeSeqByUser.set(userId, seq);
    return seq;
}

export function getLatestPreferredLocaleIntent(userId: string): SupportedLocale | undefined {
    return latestLocaleByUser.get(userId);
}

export function isPreferredLocaleWriteCurrent(userId: string, seq: number): boolean {
    return writeSeqByUser.get(userId) === seq;
}
